import { SlidersHorizontal } from "lucide-react";
import { useLanguage } from "@/context/LanguageContext";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Sheet, SheetContent, SheetHeader, SheetTitle, SheetFooter } from "@/components/ui/sheet";

/**
 * 2026-06 · 采购报价 手机端筛选抽屉 — 桌面端的一排筛选在手机上挤不下，
 * 全部收进底部抽屉，已选条件在页面上以小标签显示。
 */
export function PqMobileFilterSheet({ open, onOpenChange, value, onChange, buyers, customers, onClear }) {
  const { t } = useLanguage();
  const set = (patch) => onChange({ ...value, ...patch });

  return (
    <Sheet open={open} onOpenChange={onOpenChange}>
      <SheetContent side="bottom" className="max-h-[88vh] overflow-y-auto rounded-t-xl"
        data-testid="pq-mobile-filter-sheet">
        <SheetHeader>
          <SheetTitle className="flex items-center gap-2 text-base">
            <SlidersHorizontal size={16} /> {t("pq.mobileFilters")}
          </SheetTitle>
        </SheetHeader>

        <div className="space-y-4 py-3">
          <div className="space-y-1.5">
            <Label className="text-xs text-muted-foreground">{t("pq.date")}</Label>
            <div className="grid grid-cols-2 gap-2">
              <Input type="date" value={value.dateFrom} onChange={(e) => set({ dateFrom: e.target.value })}
                className="h-11 min-w-0 text-sm font-mono px-2" data-testid="pq-mobile-date-from" />
              <Input type="date" value={value.dateTo} onChange={(e) => set({ dateTo: e.target.value })}
                className="h-11 min-w-0 text-sm font-mono px-2" data-testid="pq-mobile-date-to" />
            </div>
          </div>

          <div className="space-y-1.5">
            <Label className="text-xs text-muted-foreground">{t("pq.salesperson")}</Label>
            <Input list="pq-mobile-buyer-options" value={value.buyer === "all" ? "" : value.buyer}
              placeholder={t("pq.allBuyers")}
              onChange={(e) => set({ buyer: e.target.value.trim() ? e.target.value : "all" })}
              className="h-11 text-base" data-testid="pq-mobile-buyer-input" />
            <datalist id="pq-mobile-buyer-options">
              {buyers.map((b) => <option key={b} value={b} />)}
            </datalist>
          </div>

          <div className="space-y-1.5">
            <Label className="text-xs text-muted-foreground">{t("pq.quoteCustomer")}</Label>
            <Input list="pq-mobile-customer-options" value={value.customer === "all" ? "" : value.customer}
              placeholder={t("pq.allCustomers")}
              onChange={(e) => set({ customer: e.target.value.trim() ? e.target.value : "all" })}
              className="h-11 text-base" data-testid="pq-mobile-customer-input" />
            <datalist id="pq-mobile-customer-options">
              {customers.map((c) => <option key={c} value={c} />)}
            </datalist>
          </div>

          <div className="space-y-1.5">
            <Label className="text-xs text-muted-foreground">{t("pq.price")}</Label>
            <div className="grid grid-cols-2 gap-2">
              <Input type="number" inputMode="decimal" value={value.priceMin}
                onChange={(e) => set({ priceMin: e.target.value })}
                placeholder={t("pq.priceMin") || "最低价"} className="h-11 min-w-0 text-base font-mono"
                data-testid="pq-mobile-price-min" />
              <Input type="number" inputMode="decimal" value={value.priceMax}
                onChange={(e) => set({ priceMax: e.target.value })}
                placeholder={t("pq.priceMax") || "最高价"} className="h-11 min-w-0 text-base font-mono"
                data-testid="pq-mobile-price-max" />
            </div>
          </div>
        </div>

        <SheetFooter className="flex-row gap-2">
          <Button variant="outline" className="flex-1 h-11" onClick={onClear} data-testid="pq-mobile-clear-filters">
            {t("pq.clearFilters")}
          </Button>
          <Button className="flex-1 h-11 bg-brand hover:bg-brand-hover" onClick={() => onOpenChange(false)}
            data-testid="pq-mobile-apply-filters">
            {t("common.done")}
          </Button>
        </SheetFooter>
      </SheetContent>
    </Sheet>
  );
}
